/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type ObserveMode = 'local' | 'flat' | 'deep';

export class ObserveModes {
  static readonly LOCAL: ObserveMode = 'local';
  static readonly FLAT: ObserveMode = 'flat';
  static readonly DEEP: ObserveMode = 'deep';
}
